import { camelize } from './ObjectKeyCase'

export class ApiClient {
  static fetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    const element = document.head.querySelector(
      'meta[name="csrf-token"]',
    ) as HTMLMetaElement
    if (element?.content) {
      headers.append('X-CSRF-TOKEN', element.content)
    }
    const newInit = init || {}
    Object.assign(newInit, { headers })
    return fetch(input, newInit)
  }

  // todo: json 渡せるようにする
  static post(input: RequestInfo, init?: RequestInit): Promise<Response> {
    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    const element = document.head.querySelector(
      'meta[name="csrf-token"]',
    ) as HTMLMetaElement
    if (element?.content) {
      headers.append('X-CSRF-TOKEN', element.content)
    }
    const newInit = init || {}
    Object.assign(newInit, {
      method: 'POST',
      headers,
    })
    return fetch(input, newInit)
  }

  static patchData(
    url: string = '',
    data: { [key: string]: any } = {},
  ): Promise<Response> {
    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    const element = document.head.querySelector(
      'meta[name="csrf-token"]',
    ) as HTMLMetaElement
    if (element?.content) {
      headers.append('X-CSRF-TOKEN', element.content)
    }
    const init = {
      method: 'PATCH',
      body: JSON.stringify(data),
      headers,
    }
    return fetch(url, init)
  }

  static delete(input: RequestInfo, init?: RequestInit): Promise<Response> {
    const headers = new Headers()
    headers.append('Content-Type', 'application/json')
    const element = document.head.querySelector(
      'meta[name="csrf-token"]',
    ) as HTMLMetaElement
    if (element?.content) {
      headers.append('X-CSRF-TOKEN', element.content)
    }
    const newInit = init || {}
    Object.assign(newInit, {
      method: 'DELETE',
      headers,
    })
    return fetch(input, newInit)
  }

  static fetchWithMultipartFormData(
    input: RequestInfo,
    init?: RequestInit,
  ): Promise<Response> {
    const headers = new Headers()
    const element = document.head.querySelector(
      'meta[name="csrf-token"]',
    ) as HTMLMetaElement
    if (element?.content) {
      headers.append('X-CSRF-TOKEN', element.content)
    }
    const newInit = init || {}
    Object.assign(newInit, { headers })
    return fetch(input, newInit)
  }
}

// API がエラーを返したことを表す Error。status でハンドリングを分けられるようにする
export class ApiError extends Error {
  status: number

  constructor(status: number, message?: string) {
    super(message || `Request failed with status ${status}`)
    this.name = 'ApiError'
    this.status = status
  }
}

// トランスパイル環境によって instanceof が期待通りに動かないことがあるため、
// status の有無で判定する
export const isApiError = (error: unknown): error is ApiError =>
  error instanceof Error && typeof (error as ApiError).status === 'number'

// 4xx（401/403/404 など）はリトライしても結果が変わらないため、再試行の可否判定に使う
export const isClientError = (error: unknown): boolean =>
  isApiError(error) && error.status >= 400 && error.status < 500

export const fetcher = async (input: RequestInfo, init?: RequestInit) => {
  const headers = new Headers()
  headers.append('Content-Type', 'application/json')
  // Devise は Accept が */* だと認証失敗をサインイン画面へのリダイレクトで返すため、
  // JSON を明示して 401 を受け取れるようにする（付けないと下の ApiError が発火しない）
  headers.append('Accept', 'application/json')
  const element = document.head.querySelector(
    'meta[name="csrf-token"]',
  ) as HTMLMetaElement
  if (element?.content) {
    headers.append('X-CSRF-TOKEN', element.content)
  }
  const newInit = init || {}
  Object.assign(newInit, { headers })
  const res = await fetch(input, newInit)
  // 401 などのエラーレスポンスのボディを正常なデータとして扱わないよう、
  // ステータスを確認してからパースする
  if (!res.ok) {
    throw new ApiError(res.status)
  }
  const data = await res.json()
  return camelize(data)
}
